export default "__VITE_ASSET__Dil2Ox5G__"